import React from "react";
import {Link} from "react-router-dom";

export const RegistrationFailed = ({ uuid, selfiePreview }) => {
    return (
        <div className="registration-result-container">
            <div className="avatar-container">
                <div className="avatar">
                    <img src={selfiePreview} alt="Your selfie"/>
                    <div className="avatar-verified">
                        <i className="fa fa-check"></i>
                    </div>
                </div>
            </div>

            <h2 className="result-title failure">Face not recognized!</h2>

            <p className="result-message">
                We regret to inform you that we were unable to detect your face from the provided selfie.
                Please try taking another selfie with your face fully visible and ensure that there is
                sufficient lighting to enhance facial recognition. Additionally, please make sure that
                there are no other faces in the image, as this can interfere with the detection process.
            </p>

            <div className="button-container">
                <Link
                    to={`/${uuid}/register`}
                    className="button button-icon"
                >
                    <i className="fa fa-refresh"></i>
                    Try Again
                </Link>
            </div>
        </div>
    );
};


export default RegistrationFailed;